import React from 'react';
import { Button, Typography, Card, List } from 'antd';

const { Title, Paragraph, Text } = Typography;

const MediaPermissionInstruction = ({ onClick }) => {
  const steps = [
    'Click "Share Screen" when the sharing dialog appears',
    'Select "Entire Screen" (not just a window or application)',
    'Grant permission when prompted by your browser',
    'Ensure your screen remains shared throughout the entire test duration',
    'Keep the test window active - do not minimize or switch to other applications',
    'Close all unnecessary programs and browser tabs before starting',
    'Disable notifications to avoid interruptions during the test',
    'Maintain a stable internet connection to prevent sharing interruptions',
  ];

  const importantPoints = [
    'Your entire screen activity will be monitored during the test',
    'Opening other applications or websites may result in test termination',
    'If screen sharing disconnects, contact technical support immediately',
  ];

  return (
    <Card style={{ maxWidth: '75%', margin: 'auto', padding: '32px' }}>
      <Typography>
        <Title level={3}>Screen Share and Camera Permission Required</Title>
        <Paragraph>
          To proceed with your examination, you must share your screen for monitoring purposes.
          Please follow these steps:
        </Paragraph>

        <List
          size="small"
          bordered={false}
          dataSource={steps}
          renderItem={(item, index) => (
            <List.Item
              style={{
                textAlign: 'justify',
                paddingLeft: 0,
                alignItems: 'flex-start',
                borderBottom: 'none',
              }}
            >
              <div style={{ display: 'flex', textAlign: 'justify' }}>
                <span style={{ minWidth: '20px' }}>{index + 1}.</span>
                <span style={{ flex: 1, textAlign: 'justify' }}>{item}</span>
              </div>
            </List.Item>
          )}
          style={{ marginBottom: 24 }}
        />

        <Title
          level={4}
          style={{ textAlign: 'left' }}
        >
          Important:
        </Title>
        <List
          size="small"
          bordered={false}
          dataSource={importantPoints}
          renderItem={item => (
            <List.Item
              style={{
                textAlign: 'justify',
                paddingLeft: 0,
                alignItems: 'flex-start',
                borderBottom: 'none',
              }}
            >
              <div style={{ display: 'flex', textAlign: 'justify' }}>
                <span style={{ minWidth: '20px' }}>•</span>
                <span style={{ flex: 1, textAlign: 'justify' }}>{item}</span>
              </div>
            </List.Item>
          )}
        />

        <Paragraph style={{ marginTop: 24 }}>
          <Text strong>Need Help?</Text> Contact our support team at{' '}
          <Text type="secondary">[support contact]</Text> if you experience any technical
          difficulties.
        </Paragraph>
        <Button
          type="primary"
          size="large"
          onClick={onClick}
          style={{ marginTop: 32 }}
        >
          I Understand and Agree
        </Button>
      </Typography>
    </Card>
  );
};

export default MediaPermissionInstruction;
